import { Link } from "react-scroll";
import Section from "./Section";

const AboutSection = () => {
    return (
        <Section id="about" label="About" bgClass="about-bg">
            {(visible) => (
                <div className="section-content animate-on-scroll">
                    {/* Left side */}
                    <div className="section-left">
                        <div className="left-content-box">
                            <div className="text-bg">
                                <h2
                                    className={`left-title ${
                                        visible ? "animate-title" : ""
                                    }`}
                                    style={{
                                        animationDelay: visible ? "0.2s" : "0s",
                                    }}
                                >
                                    Software Quality Assurance Test Professionals
                                </h2>
                                <p
                                    className={`left-desc ${
                                        visible ? "animate-desc" : ""
                                    }`}
                                    style={{
                                        animationDelay: visible ? "0.7s" : "0s", // 0.5s after title
                                    }}
                                >
                                    At Shift Left, we help teams integrate quality assurance early in the software development lifecycle. 
                                    Our manual testing, automation testing, and QA consultation services are designed to reduce risk, accelerate delivery, and improve user experience.

                                    <br />
                                    <br />

                                    QA testing shouldn’t be complicated or costly. We make it clear, effective, and results driven allowing your business to deliver reliable, high-quality software at scale.
                                </p>

                            </div>
                        </div>
                    </div>

                    <div className="section-divider" />

                    {/* Right side */}
                    <div className="section-right">
                        <div
                            className={`right-content ${
                                visible ? "animate-right" : ""
                            }`}
                            style={{
                                animationDelay: visible ? "0.2s" : "0s",
                            }}
                        >
                            <h3>What sets us apart?</h3>
                            <ul
                                style={{ listStyle: "disc", marginLeft: "2em" }}
                            >
                                <li>
                                    <strong>Scalable QA Solutions:</strong> We tailor our services to fit your growth, from startup to enterprise.
                                </li>
                                <li>
                                    <strong>Early Testing Integration:</strong>{" "}
                                    We shift QA to the left of your SDLC, helping your team catch issues before they become costly. Faster feedback, fewer delays, better releases.
                                </li>
                                <li>
                                    <strong>Customer Centric Focus:</strong>{" "}
                                    Your success drives everything we do. Our QA strategy adapts to your product, team, and goals
                                </li>
                            </ul>

                            <h3>A Partner in Quality</h3>
                            <p>
                                We know you’re not just delivering a product, you're delivering high quality software to your customers. More than just a QA testing company, we're your partners in launching realiable, scalable, high quality user experiences.
                            </p>
                        </div>
                        <div
                            className={`right-cta ${
                                visible ? "animate-right-cta" : ""
                            }`}
                            style={{
                                animationDelay: visible ? "0.7s" : "0s", // 0.5s after right text
                            }}
                        >
                            <Link
                                to="contact"
                                smooth={true}
                                duration={500}
                                offset={-70}
                            >
                                <button className="cta-btn">
                                    Reach Out Now
                                </button>
                            </Link>
                        </div>
                    </div>
                </div>
            )}
        </Section>
    );
};

export default AboutSection;
